module.exports = __webpack_public_path__ + "static/img/meeting_bg_513.fb15060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Meeting/meeting_bg_513.png
// module id = Hu1b
// module chunks = 4